import { get } from 'lodash';

import { config, msg } from 'api';

import { pageEventTypes, wa } from 'apps/analytics';

import { setErrorMessage } from 'apps/notifications/actions/notifications';
import errorHandler from 'lib/utils/errorHandler';

export const DELIVERY_ADDRESS_SET_UP = 'DELIVERY_ADDRESS_SET_UP';
export const MOBILE_PHONE_NUMBER_FILLED = 'MOBILE_PHONE_NUMBER_FILLED';
export const CONTACT_DETAILS_VALIDATION_ERRORS = 'CONTACT_DETAILS_VALIDATION_ERRORS';
export const SET_CONTACT_DETAILS = 'SET_CONTACT_DETAILS';

export function setContactDetails(contactDetails) {
  return {
    type: SET_CONTACT_DETAILS,
    contactDetails,
  };
}

export function contactDetailsValidationError(fieldErrors) {
  return {
    type: CONTACT_DETAILS_VALIDATION_ERRORS,
    validationErrors: fieldErrors,
  };
}

export function getContactDetails() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/contact`)
      .then(response => dispatch(setContactDetails(response)))
      .catch(errorHandler);
}

const backendErrors = {
  ACTIVE_SLOT_SUBSCRIPTION: [{
    field: 'secondaryNumber',
    code: 'SlotSubscription',
  }],
  PHONE_NUMBER_USED_FOR_SMS_ALERTS: [{
    field: 'primaryNumber',
    code: 'SmsAlerts',
  }],
  MOBILE_PHONE_NUMBER_USED_FOR_SMS_ALERTS: [{
    field: 'secondaryNumber',
    code: 'SmsAlerts',
  }],
};

const extractValidationErrors = (response) => {
  if (get(response, 'data.fieldErrors')) {
    return get(response, 'data.fieldErrors');
  }
  return backendErrors[get(response, 'data.code')];
};

export function saveContactDetails(details) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/contact`,
      {
        body: JSON.stringify({
          ...details,
        }),
      })
      .then(() => {
        dispatch(setContactDetails(details));
        wa.triggerPageEvent(pageEventTypes.CONTACT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED);
        return true;
      })
      .catch((response) => {
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        wa.triggerPageEvent(pageEventTypes.CONTACT_DETAILS_FAILURE_NOTIFICATION_DISPLAYED);
        if (get(response, 'status') === 412) {
          const validationErrors = extractValidationErrors(response);
          if (validationErrors) {
            dispatch(contactDetailsValidationError(validationErrors));
            return false;
          }
        }
        return false;
      });
}
